import type { SxProps, Theme } from "@mui/material/styles";
import { theme as appTheme } from "../../utils/theme";

export const EXPLORER_CHIP_BG = "#E8ECE8";

export const EXPLORER_BTN_SHADOW =
  "0px 3px 8px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.1)";

export const EXPLORER_BTN_SHADOW_ACTIVE =
  "0px 2px 6px rgba(0, 127, 24, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.08)";

export const EXPLORER_CARD_SHADOW =
  "0px 4px 10px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.08)";

/** Chiều cao thống nhất ô pill + nút Search (mobile explorer) */
export const EXPLORER_SEARCH_ROW_HEIGHT = 48;

export const explorerFilterGridSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 1.25,
};

export function getExplorerFilterChipSx(active: boolean): SxProps<Theme> {
  return {
    minHeight: 48,
    px: 1,
    py: 1.25,
    borderRadius: "12px",
    bgcolor: EXPLORER_CHIP_BG,
    color: active
      ? appTheme.palette.common.green
      : appTheme.palette.text.primary,
    fontWeight: active ? 700 : 600,
    fontSize: 14,
    lineHeight: 1.2,
    border: "none",
    cursor: "pointer",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: active ? EXPLORER_BTN_SHADOW_ACTIVE : EXPLORER_BTN_SHADOW,
    transition: "box-shadow 0.2s ease, transform 0.12s ease",
    WebkitTapHighlightColor: "transparent",
    "&:active": {
      transform: "scale(0.98)",
    },
  };
}

/** Trang explorer: không padding ngang — header + content tự chừa px: 2 */
export const explorerRootSx: SxProps<Theme> = {
  bgcolor: "#fff",
  minHeight: "100vh",
  boxSizing: "border-box",
};

/** Nội dung cuộn bên dưới header sticky */
export const explorerContentSx: SxProps<Theme> = {
  px: 2,
  pt: 1.25,
  pb: 3,
};

/** @deprecated Dùng explorerRootSx + explorerContentSx để hỗ trợ header sticky */
export const explorerScreenShellSx: SxProps<Theme> = {
  bgcolor: "#fff",
  minHeight: "100vh",
  px: 2,
  pt: "calc(12px + env(safe-area-inset-top, 0px))",
  pb: 3,
  boxSizing: "border-box",
};
